<div class="right-side p-5">
  <h2>On the spot attendance</h2>

  <div class="section">
    <!-- Top Action Button -->
    <div class="row">

      <div class="text-end">



  <!-- Update Spot Attendance -->
  <button
    class="btn btn-sm btn-success me-2"
    (click)="onSpotRegistration()"
  >
    <i class="bi bi-pencil-square me-1"></i>
    Update Spot Attendance
  </button>


  <!-- Export To Excel -->
  <button
    class="btn btn-sm btn-primary"
    (click)="exportToExcel()"
  >
    <i class="bi bi-file-earmark-excel me-1"></i>
    Export To Excel
  </button>

</div>


      <!-- 🔍 Filters -->
      <div class="col-lg-7 col-sm-12">
        <!-- Search -->
        <mat-form-field appearance="outline" class="search-input w-75">
          <mat-label>Search...</mat-label>
          <input
            matInput
            [(ngModel)]="pagination.searchTerm"
            (keyup.enter)="loadData()"
          />
        </mat-form-field>

        <!-- Search Button -->
        <button
          class="btn btn-outline-secondary p-2 mx-1 search-button"
          (click)="loadData()"
        >
          <i class="bi bi-search fs-4"></i>
        </button>

        <!-- Reset Button -->
        <button class="btn btn-outline-secondary p-2" (click)="resetFilters()">
          <i class="bi bi-arrow-clockwise fs-4"></i>
        </button>
      </div>
    </div>
  

    <div class="table-responsive">

  <table class="table table-striped table-bordered table-hover">

    <thead>
      <tr>

        <th>Sr.No</th>

        <th (click)="sort('IAName')">
          IA User Name ⬍
        </th>

        <th (click)="sort('EventId')">
          Event ID ⬍
        </th>

        <th (click)="sort('EventName')">
          Event Name ⬍
        </th>

        <th (click)="sort('Intervention')">
          Intervention ⬍
        </th>

        <th (click)="sort('Component')">
          Component ⬍
        </th>

        <th (click)="sort('EventDate')">
          Event Date ⬍
        </th>

        <th (click)="sort('OriginalFileName')">
          File Name ⬍
        </th>

        <th>Success</th>

        <th>Failed</th>

        <th>Old Count</th>

        <th>Revise Count</th>

      </tr>
    </thead>

    <tbody>

      <tr *ngFor="let row of excelData; let i = index">

        <td>
          {{ (pagination.pageNumber - 1) * pagination.pageSize + i + 1 }}
        </td>

        <td>
          {{ row.IAName }}
        </td>

        <td>
          {{ row.EventId }}
        </td>

        <td>
          {{ row.EventName }}
        </td>

        <td>
          {{ row.Intervention }}
        </td>

        <td>
          {{ row.Component }}
        </td>

        <td>
          {{ row.EventDate | date:'dd-MM-yyyy' }}
        </td>

        <td>
          <a
            href="javascript:void(0)"
            (click)="downloadFile(row)"
          >
            {{ row.OriginalFileName }}
          </a>
        </td>

        <!-- Success -->
        <td>
          <a
            href="javascript:void(0)"
            (click)="MSMEPopupvalid(row, 'valid')"
          >
            {{ row.ValidMsmeCount }}
          </a>
        </td>

        <!-- Failed -->
        <td>
          <a
            href="javascript:void(0)"
            (click)="MSMEPopupNotValid(row, 'notvalid')"
          >
            {{ row.NotValidMsmeCount }}
          </a>
        </td>

        <!-- Old Count -->
    <!-- Old Count -->
<td>
  {{
    (row.OnSpotRegistrationCount || 0) -
    (row.ValidMsmeCount || 0)
  }}
</td>

<!-- Revise Count -->
<td>
  {{
    (row.OnSpotRegistrationCount || 0) 
  }}
</td>

      </tr>

      <!-- No Data -->
      <tr *ngIf="excelData.length === 0">
        <td colspan="12" class="text-center">
          No data available
        </td>
      </tr>

    </tbody>

  </table>

</div>

    <!-- 📊 Material Pagination -->
    <mat-paginator
      [length]="totalRecords"
      [pageSize]="pagination.pageSize"
      [pageIndex]="pagination.pageNumber - 1"
      [pageSizeOptions]="[5, 10, 20, 50]"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>

<div *ngIf="isPopupOpen" class="modal-backdrop">
  <div class="modal-box">
    <!-- Header -->
    <!-- <div class="modal-header">
      <h3>MSME Details</h3>- {{EventName}}
      <button class="close-btn" (click)="closePopup()">×</button>
    </div> -->

    <div class="modal-header d-flex justify-content-between align-items-center px-4 py-3 border-bottom">

  <!-- Left Section -->
  <div>
    <h3 class="mb-1 fw-bold text-dark">
      MSME Details
    </h3>

    <div class="text-muted small">
      <i class="bi bi-calendar-event me-1"></i>
      {{ EventId }}
    </div>
  </div>

  <!-- Right Section -->
  <button
    type="button"
    class="btn btn-light  shadow-sm close-btn"
    (click)="closePopup()"
  >
    ×
  </button>

</div>

    <!-- Total Count -->
    <p class="total-count" *ngIf="type == 'valid'">
      Total Success Records: {{ onspotvalidData?.length }}
    </p>
    <p class="total-count" *ngIf="type == 'notvalid'">
      Total Failed Records: {{ onspotvalidData?.length }}
    </p>

    <!-- Table -->
    <div class="table-responsive">
      <table
        class="styled-table table table-striped table-bordered table-hover"
      >

        <thead>
          <tr>
            <th>UdyamNumber</th>
            <th>Participant Name</th>
            <th>Mobile No</th>
            <th>Email</th>
            <th>Enterprise Name</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of onspotvalidData">
            <td>{{ item.UdyamNumber }}</td>
            <td>{{ item.ParticipantName }}</td>
            <td>{{ item.MobileNo }}</td>
            <td>{{ item.Email }}</td>
            <td>{{ item.EnterpriseName }}</td>
          </tr>

          <!-- No Data -->
          <tr *ngIf="onspotvalidData?.length === 0">
            <td colspan="5" class="no-data">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
